import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Box, Button } from '@mui/material';
import { openResources } from '../authConfig';
import { useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom';

interface RippleData {
  do: string;
  lastOff: string;
  lastOn: string;
  currentStatus: string;
}

interface RippleLastOnOffDetailProps {
  coop: string;
}

export default function RippleLastOnOffDetail({coop}: RippleLastOnOffDetailProps) {
  const { loadGroup } = useParams<{ loadGroup: string }>();
  const [searchParams] = useSearchParams();

  //const hideHeader = searchParams.get('hideHeader') === 'true';
  //const coop = searchParams.get('coop') ?? 'minnkota';
  const location = useLocation();
  const queryString = location.search;

  const [data, setData] = useState<RippleData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const formatDateOrDash = (value: any) => {
    const date = new Date(value);
    return value && !isNaN(date.getTime()) ? date.toLocaleString() : '---';
  };

  const getColor = (value: string) => {
    if (value === 'ON') return 'rgb(0, 95, 0)';
    if (value === 'OFF') return 'rgb(139, 0, 0)';
    return 'inherit';
  }

  const getTextColor = (value: string) => {
    if (value === 'ON') return 'white';
    if (value === 'OFF') return 'white';
    return 'black';
  }

  const navigate = useNavigate();

  useEffect(() => {
    const fetchRippleData = async () => {
      try {
        const response = await axios.get(openResources.ripple.lastOnOffEndpoint, {
          params: { area: coop, loadGroup: loadGroup }
        });
 
        if (response.data && Array.isArray(response.data)) {
          const formatted = response.data.map((item: any) => ({
            do: item.do,
            lastOff: item.lastOff,
            lastOn: item.lastOn,
            currentStatus: item.currentStatus
          }));
          setData(formatted);
        } else {
          setData([]);
        }
      } catch (err: any) {
        setError('Error fetching ripple data: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRippleData();
  }, [loadGroup]);

  if (loading) return <div>Loading ripple data...</div>;
  if (error) return <div>{error}</div>;

  return (
    <Box sx={{ maxWidth: 1200, margin: 'auto', mt: 4 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/detail' + queryString)}
        sx={{ mb: 2 }}
      >
        ← Back to Detail
      </Button>
      <h2>Ripple Status for Load Group {loadGroup}</h2>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Double Order</TableCell>
              <TableCell>Last Off</TableCell>
              <TableCell>Last On</TableCell>
              <TableCell>Current Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.do}</TableCell>
                <TableCell style={{backgroundColor: 'rgb(139, 0, 0)', color:'white'}} >{formatDateOrDash(row.lastOff)}
                </TableCell>
                <TableCell style={{backgroundColor: 'rgb(0, 95, 0)', color:'white'}}>{formatDateOrDash(row.lastOn)}
                </TableCell>
                <TableCell style={{backgroundColor: getColor(row.currentStatus), color:getTextColor(row.currentStatus)}} >{row.currentStatus ?? '---'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
